<template>
  <div class="table-container">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-table ref="tableSort" v-loading="loading" :data="list" border>
          <el-table-column
            label="序号"
            align="center"
            width="80"
            type="index"
          ></el-table-column>
          <el-table-column label="发生时间" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.time || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="直接责任财务人员">
            <template slot-scope="scope">
              {{ scope.row.financialPeople || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="直接责任中介机构">
            <template slot-scope="scope">
              {{ scope.row.agencyPeople || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="案件性质">
            <template slot-scope="scope">
              {{ scope.row.caseType || "-" }}
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100px"
            fixed="right"
            align="center"
            fit="true"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="查看详情"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-document"
                  circle
                  @click="showDetail(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--分页模块-->
    <el-row v-if="total > 0" :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-card>
          <el-pagination
            :current-page="queryForm.pageNum"
            :page-size="queryForm.pageSize"
            :total="total"
            :background="background"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!--查看详情-->
    <el-dialog
      title="重大税收违法信息详情"
      :visible.sync="flag"
      :close-on-click-modal="false"
      width="50%"
      append-to-body
      @close="close"
    >
      <table
        class="info-table"
        cellspacing="0"
        style="width: 100%; height: 100%"
      >
        <tbody>
          <tr>
            <td>主要违法事实</td>
            <td>{{ report.truth || "-" }}</td>
          </tr>
          <tr>
            <td>相关法律依据及,税务处理处罚情况</td>
            <td>{{ report.lawPunishment || "-" }}</td>
          </tr>
        </tbody>
      </table>
    </el-dialog>
  </div>
</template>

<script>
  import { getHugeTaxPunishment } from "@/api/workplace/companyInfo";

  export default {
    // 重大税收违法案件信息
    name: "TaxAgainLaw",

    data() {
      return {
        flag: false,
        list: [],
        loading: false,
        total: 0,
        background: true,
        layout: "total, sizes, prev, pager, next, jumper",
        queryForm: {
          body: {
            keyword: "",
            seqId: "",
            skip: 0,
          },
          header: {
            currentTime: "",
            requestId: "2b81a030-bf6c-11ea-a387-f8a2d6d9d88d",
            sourceType: "site",
          },
          pageNum: 1,
          pageSize: 20,
        },
        report: {},
        obj: null,
      };
    },

    methods: {
      // todo 没有重大税收违法案件信息接口
      getHugeTaxPunishment(param) {
        this.loading = true;
        this.obj = param;
        this.queryForm.body.keyword = param.keyword;
        this.queryForm.body.seqId = param.seqId;
        this.queryForm.body.pageSize = this.queryForm.pageNum * 20;
        getHugeTaxPunishment(this.queryForm)
          .then((response) => {
            if (response.header.retCode === "1") {
              this.list = response.body.items;
              this.total = response.body.total;
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      },
      handleSizeChange(val) {
        this.queryForm.pageSize = val;
        this.getHugeTaxPunishment(this.obj);
      },
      handleCurrentChange(val) {
        this.queryForm.pageNum = val;
        this.getHugeTaxPunishment(this.obj);
      },
      showDetail(row) {
        this.flag = true;
        this.report = row;
      },
      close() {
        this.flag = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .info-table {
    border-collapse: collapse;
    font-size: 14px;
    color: #333;

    tr td {
      border: 1px solid #ccc;
      padding: 10px;

      &:nth-of-type(even) {
        width: 35%;
        font-weight: normal;
      }

      &:nth-of-type(odd) {
        width: 15%;
        background: #f5f7fa;
      }
    }
  }
</style>
